<template></template>
<script>
export default {
    name    :   'WindowResizeHandler',
    mounted()
    {
        this.$bus.$on('onWindowSize', this.handle_window_resize);
        this.$nextTick().then(() => {
            $(window).resize();
        });
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowSize', this.handle_window_resize);
    },
    methods :   {
        handle_window_resize(width)
        {

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/WindowResizeHandler.vue